<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Нэвтрэх нэр солих"
      scrollable
      no-fade
      centered
      size="sm"
      hide-footer
      @hide="cancel()"
    >
      <Form :model="passModel" label-width="160">
        <FormItem label="Шинэ нэвтрэх нэр" class="m-b-sm">
          <Input v-model="passModel.new" placeholder="___" />
        </FormItem>
        <!-- <FormItem class="m-b-sm">
          <Button size="large" @click="changePass()" type="primary" icon="ios-checkmark">Хадгалах</Button>
        </FormItem> -->
      </Form>
      <div class="text-center pd-t-20">
        <button @click="changePass()" class="btn btn-primary">Хадгалах</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Form, Input, FormItem, Button } from "element-ui";

export default {
  components: {
    Form,
    FormItem,
    Input,
    Button
  },
  name: "mdlUserpassChangeComp",
  props: {
    taskId: {
      type: Number,
      default: () => null
    },
    json: {
      type: Object,
      default: () => null
    },
    isShow: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rolesReady: false,
      roles: [],
      userRoles: [],
      passModel: {
        taskId: 0,
        locTypeId4: 0,
        new: "",
        userId: ""
      },
      showModal: false
    };
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        this.passModel = this.json;
        this.showModal = true;
        this.init();
      }
    }
  },
  methods: {
    init() {},
    changePass() {
      let errs = [];

      if (this.passModel.new.length <= 0) {
        errs.push("Шинэ нэвтрэх нэр оруулна уу !");
      }
      //   else if (this.passModel.new.length < 6) {
      //     errs.push("Нууц үг хамгийн багадаа 6 тэмдэгт байна !");
      //   }

      if (errs.length == 0) {
        // ChangeUserPassword({
        //   userId: this.passModel.userId,
        //   password: this.passModel.new
        // })

        //
        request({
          api: { method: "post", url: "auth/ChangeUserLogin" },
          data: {
            userId: this.passModel.userId,
            login: this.passModel.new
          },
          store: self.$store
        }).then(res => {
          if (res != false) {
            // this.$Notice.success({
            //   title: "Амжилттай",
            //   desc: res.msg
            // });
            this.$bvToast.toast("Амжилттай", {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true
            });

            this.passModel.new = "";
            this.passModel.userId = "";

            this.cancel();
          }
        });
      } else {
        for (var i = 0; i < errs.length; i++) {
          this.$Notice.warning({
            title: "Мэдэгдэл",
            desc: errs[i]
          });
        }
      }
    },
    cancel() {
      this.showModal = false;
      this.$emit("on-close");
    }
  }
};
</script>

<style></style>
